export type Locale = 'en' | 'zh' | 'ja' | 'ko' | 'fr' | 'de' | 'es';

export const localeNames: Record<Locale, { name: string; flag: string }> = {
  en: { name: 'English', flag: '🇺🇸' },
  zh: { name: '中文', flag: '🇨🇳' },
  ja: { name: '日本語', flag: '🇯🇵' },
  ko: { name: '한국어', flag: '🇰🇷' },
  fr: { name: 'Français', flag: '🇫🇷' },
  de: { name: 'Deutsch', flag: '🇩🇪' },
  es: { name: 'Español', flag: '🇪🇸' },
};

export interface Translations {
  common: {
    home: string;
    github: string;
    copy: string;
    clear: string;
    input: string;
    output: string;
    encode: string;
    decode: string;
    generate: string;
    convert: string;
    result: string;
    copiedToClipboard: string;
    failedToCopy: string;
    language: string;
  };
  seo: {
    siteDescription: string;
    keywords: string[];
    ogTitle: string;
    ogDescription: string;
  };
  home: {
    title: string;
    subtitle: string;
    whyTitle: string;
    privacyTitle: string;
    privacyDesc: string;
    fastTitle: string;
    fastDesc: string;
    freeTitle: string;
    freeDesc: string;
    footer: string;
    footerSubtitle: string;
  };
  tools: {
    jsonFormatter: {
      name: string;
      description: string;
      format: string;
      minify: string;
      validate: string;
      error: string;
    };
    base64: {
      name: string;
      description: string;
      encodeButton: string;
      decodeButton: string;
    };
    uuid: {
      name: string;
      description: string;
      numberOfUuids: string;
      generatedUuids: string;
      copyAll: string;
      aboutTitle: string;
      aboutDesc: string;
    };
    hash: {
      name: string;
      description: string;
      inputText: string;
      securityNotice: string;
      securityDesc: string;
    };
    urlEncoder: {
      name: string;
      description: string;
      encodeUrl: string;
      encodeComponent: string;
      encoded: string;
      decoded: string;
      differenceTitle: string;
      encodeUriDesc: string;
      encodeComponentDesc: string;
      examples: string;
    };
    timestamp: {
      name: string;
      description: string;
      currentTime: string;
      unixMs: string;
      unixS: string;
      toDate: string;
      toTimestamp: string;
      useNow: string;
      aboutTitle: string;
      aboutDesc1: string;
      aboutDesc2: string;
      aboutDesc3: string;
      aboutDesc4: string;
    };
    color: {
      name: string;
      description: string;
      pickColor: string;
      formatGuide: string;
      hexDesc: string;
      rgbDesc: string;
      hslDesc: string;
      alphaDesc: string;
    };
    jwt: {
      name: string;
      description: string;
      inputToken: string;
      header: string;
      payload: string;
      signature: string;
      claims: string;
      invalidFormat: string;
      invalidToken: string;
      securityNotice: string;
      securityDesc: string;
      aboutTitle: string;
      aboutDesc1: string;
      aboutDesc2: string;
      aboutDesc3: string;
    };
    diff: {
      name: string;
      description: string;
      originalText: string;
      modifiedText: string;
      sideBySide: string;
      unified: string;
      noDifference: string;
    };
    markdown: {
      name: string;
      description: string;
      editor: string;
      preview: string;
      supportedFeatures: string;
    };
    regex: {
      name: string;
      description: string;
      pattern: string;
      flags: string;
      testString: string;
      matches: string;
      noMatches: string;
      invalidRegex: string;
      globalFlag: string;
      caseInsensitive: string;
      multiline: string;
      dotAll: string;
    };
    qrCode: {
      name: string;
      description: string;
      inputData: string;
      qrCodeImage: string;
      size: string;
      errorCorrection: string;
      errorLow: string;
      errorMedium: string;
      errorQuartile: string;
      errorHigh: string;
      templates: string;
      templateUrl: string;
      templateEmail: string;
      templatePhone: string;
      templateSms: string;
      templateWifi: string;
      templateVcard: string;
      privacyNotice: string;
      privacyDesc: string;
    };
    lorem: {
      name: string;
      description: string;
      generateType: string;
      paragraphs: string;
      sentences: string;
      words: string;
      count: string;
      startWithLorem: string;
      generatedText: string;
      aboutTitle: string;
      aboutDesc: string;
    };
    htmlEntity: {
      name: string;
      description: string;
      inputText: string;
      encodeBasic: string;
      encodeAll: string;
      decode: string;
      commonEntities: string;
      character: string;
      entity: string;
      description2: string;
      useCases: string;
      useCase1: string;
      useCase2: string;
      useCase3: string;
    };
  };
}
